import React from 'react';
import CartLanding from '../../components/CartLanding';
import LayoutWrapper from '../../components/LayoutWrapper';

const CartPage = () => {
	return (
		<LayoutWrapper>
			<CartLanding />
		</LayoutWrapper>
	);
};

export default CartPage;
